import { CommonModule, DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserModel, UserService } from 'src/app/core/authen';
import { PaymentProjectModel, ServicesService } from 'src/app/core/laboratory';

@Component({
  selector: 'app-payment-project',
  templateUrl: './payment-project.component.html',
  styleUrls: ['./payment-project.component.scss'],
  standalone: true,
  imports: [CommonModule],
  encapsulation: ViewEncapsulation.None
})
export class PaymentProjectComponent implements OnInit {

  projectId: number = 0;
  serviceId: number = 0;

  quotationForm: PaymentProjectModel = <PaymentProjectModel>{};
  users: Array<UserModel> = [];

  dateNow: string;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private servicesService: ServicesService,
    private datePipe: DatePipe,
    private userService: UserService,
    private cd: ChangeDetectorRef,
  ) {
    this.dateNow = datePipe.transform(new Date(), 'yyyy-MM-dd');
  }

  ngOnInit(): void {
    this.quotationForm = new PaymentProjectModel();
    this.quotationForm.clear();

    this.activatedRoute.params.subscribe((params) => {
      const _serviceId = params['serviceId'];
      const _projectId = params['projectId'];
      if (_projectId && _serviceId) {
        this.serviceId = Number(_serviceId);
        this.projectId = Number(_projectId);
      }
    });

    this.getDataOption();
  }

  /**
   * get data option
   */
  getDataOption() {
    this.userService
      .getAllUserByGroupId(8)
      .subscribe((res: UserModel[]) => {
        if (res) {
          this.users = res;
          this.getDataTable();
        }
      })
  }

  /**
   * get data table
   */
  getDataTable() {
    this.servicesService
      .getPaymentProjectById(this.serviceId, this.projectId)
      .subscribe((res: PaymentProjectModel) => {
        if (res) {
          this.quotationForm = res;

          this.cd.detectChanges();
          setTimeout(() => {
            this.fitToPage();
            setTimeout(() => { window.print(); }, 200);
          }, 300);
        }
      })
  }

  /**
   * Scale content to fit within one A4 page
   */
  private fitToPage(): void {
    const divFooter = document.querySelector('.divFooter') as HTMLElement;
    if (!divFooter) return;

    const a4Height = 1122; // 297mm in px at 96dpi
    const contentHeight = divFooter.scrollHeight;

    if (contentHeight > a4Height) {
      const scale = a4Height / contentHeight;
      // Use CSS zoom instead of transform — print engine respects zoom but not transform
      (divFooter.style as any).zoom = scale.toFixed(4);
    }
  }

  /**
   * method name
   */
  getMethodName(id: number): string {
    let name = '';

    if (id == 1) {
      name = 'PO&nbsp;&nbsp;ใบสั่งซื้อ'
    } else if (id == 2) {
      name = 'Cash&nbsp;&nbsp;เงินสด'
    } else if (id == 3) {
      name = 'Transfer&nbsp;&nbsp;โอนเงิน'
    }

    return name;
  }

  /**
   * get proposed name
   */
  getProposedName() {
    let user = this.users.find(e => e.id == this.quotationForm.proposedId);

    let name = user ? '(&nbsp;' + user.fName + '&nbsp;&nbsp;' + user.lName + '&nbsp;)' : '';

    return name;
  }

  /**
   * get authorized name
   */
  getAuthorizedName() {
    let user = this.users.find(e => e.id == this.quotationForm.authorizedId);

    let name = user ? '(&nbsp;' + user.fName + '&nbsp;&nbsp;' + user.lName + '&nbsp;)' : '';

    return name;
  }

  /**
   * get product type
   */
  getProductType(element: PaymentProjectModel) {
    if (element.laboratory) {
      return element.laboratory;
    } else if (element.rapidPrototy) {
      return element.rapidPrototy;
    } else if (element.designSimulation) {
      return element.designSimulation;
    } else if (element.patentTrademark) {
      return element.patentTrademark;
    } else if (element.productRegistrationSupport) {
      return element.productRegistrationSupport;
    } else if (element.otherService) {
      return element.otherService;
    } else if (element.projectManagement) {
      return element.projectManagement;
    }
  }

  /**
   * get product no name
   */
  getProductNo(element: PaymentProjectModel): string {
    let projectType = this.getProductType(element);
    let result = projectType.no;
    return result;
  }

  /**
   * customer name
   */
  getProjectDate(element: PaymentProjectModel): string {
    let projectType = this.getProductType(element);
    let result = projectType ? projectType.creationDateTime : '';
    return result;
  }

  dot(): string {
    let result = '(';

    for (let i = 0; i < 85; i++) {
      if (i == 84) {
        result = result + ')';
      } else {
        result = result + '&nbsp;';
      }
    }

    return result;
  }

}
